
<template>
  <div class="yxtbiz-college-selector">
    <yxt-tree v-if="colleges && colleges.length > 0"
      :data="colleges"
      :props="defaultProps"
      wrap-width="100%"
      @node-click="handleNodeClick"
      node-key="id"
      ref="cataTree">
      <span class="ellipsis" slot-scope="{ node }">{{node.label}}</span>
    </yxt-tree>
    <yxt-empty v-else class="mt20">
      暂无数据
    </yxt-empty>
  </div>
</template>

<script>
import { getCollegeList } from './service';
export default {
  name: 'YxtbizCollegeSelector',
  name_zh: '选择学院',
  eventList: [{
    type: 'change',
    handler: 'input',
    label: '点击选择后的事件'
  }, {
    type: 'change',
    handler: 'select',
    label: '点击选择后的事件'
  }],
  props: {
    value: {
      type: Object,
      default: () => {
        return {
          id: '',
          collegeName: ''
        };
      },
      desc: '当前选择的学院对象，包含id、collegeName',
      setter: 'JsonSetter'
    }
  },
  data() {
    return {
      loading: true,
      defaultProps: {
        children: 'children',
        label: 'collegeName'
      },
      colleges: [],
      checkedDatas: []
    };
  },
  created() {
    this.init();
  },
  mounted() {
  },
  methods: {
    handleNodeClick(clg) {
      if (this.isMulti) {
        const indexOld = this.checkedDatas.findIndex((data) => {
          return data.id === clg.id;
        });
        if (indexOld >= 0) {
          this.checkedDatas.splice(indexOld, 1);
          this.$nextTick(() =>{
            this.$refs.cataTree.setCurrentKey();
          });
        } else {
          this.checkedDatas.push(clg);
        }
        const outPut = [...this.checkedDatas];
        this.$emit('input', outPut);
        this.$emit('select', outPut);
        this.setMultiCheck();
      } else {
        this.$emit('input', clg);
        this.$emit('select', clg);
      }
    },
    init() {
      getCollegeList()
        .then(result => {
          this.colleges = result;
          this.loading = false;
          this.$nextTick(() => {
            if (this.value && this.value.length !== undefined) {
              // 多选
              this.isMulti = true;
              this.checkedDatas = [...this.value];
              this.setMultiCheck();
            } else if (this.value && this.value.id) {
              // 单选
              this.$refs.cataTree.setCurrentKey(this.value.id);
            }
          });
          this.$emit('loaded', this.colleges);
        })
        .catch(e => {
          console.log(e);
          this.loading = false;
        });
    },
    setMultiCheck() {
      if (!this.isMulti) {
        return;
      }
      this.$refs.cataTree.setCheckedKeys(this.checkedDatas.map((data) => {
        return data.id;
      }));
    }
  }
};
</script>
